import { render } from "./FormRadioButton.vue?vue&type=template&id=3ad2a0f9&scoped=true"
import script from "./FormRadioButton.vue?vue&type=script&lang=js"
export * from "./FormRadioButton.vue?vue&type=script&lang=js"

import "./FormRadioButton.vue?vue&type=style&index=0&id=3ad2a0f9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad2a0f9"]])

export default __exports__